module.exports = __webpack_public_path__ + "img/Dropsmart-V-day-cheat-sheet.72052b7b.png";